import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77164a6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rework" }
const _hoisted_2 = { class: "rework_list" }
const _hoisted_3 = { class: "rework_list_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前工厂", -1))
const _hoisted_5 = { class: "rework_list_item_right" }
const _hoisted_6 = { style: {"color":"#000"} }
const _hoisted_7 = { class: "rework_list_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出库仓库", -1))
const _hoisted_9 = { class: "rework_list_item_right" }
const _hoisted_10 = { style: {"color":"#000"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入库仓库", -1))
const _hoisted_12 = { class: "rework_list_item_right" }
const _hoisted_13 = { class: "rework_list_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报废原因", -1))
const _hoisted_15 = { class: "rework_list_item_right" }
const _hoisted_16 = { class: "rework_qd" }
const _hoisted_17 = { class: "rework_qd_title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x" }, null, -1))
const _hoisted_19 = { class: "rework_qd_item" }
const _hoisted_20 = { class: "rework_qd_item_i" }
const _hoisted_21 = { class: "black" }
const _hoisted_22 = { class: "black" }
const _hoisted_23 = { class: "rework_qd_item_i" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物料信息：", -1))
const _hoisted_25 = { class: "rework_qd_item_i" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "批次号：", -1))
const _hoisted_27 = { class: "rework_qd_item_i" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产工序：", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rework_zw" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"22px"} }, null, -1))

import { onMounted, ref, reactive } from 'vue'
  import { useRoute, useRouter } from "vue-router"
  import { Toast } from 'vant'
  import { getBarcodeContent, getListByCondition, createSingle } from '@/apis/WorkOrderAPI'
  import { QRCodeType } from "@/enum"
  import Warehouse from '@/components/common/Warehouse.vue'


    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()
    const router = useRouter()
    // 表单数据
    let form = reactive({
        warehouseName: '',
        warehouseId: '',
        reason: ''
    })

    // 报废清单
    let list = ref<Array<any>>([])
    let warehouseShow = ref<boolean>(false)

    let tempFactoryName = ref<string>()
    let tempFactoryId = ref<string>()
    let tempWarhouseName= ref<string>()
    let tempWarhouseId = ref<string>()

    let openCode = ref<boolean>(false)
    // 提交
    const onConfirm = async (value: any) => {

         let res = await createSingle({
            type: 3,
            factoryId: tempFactoryId.value,
            tempFactoryName: tempFactoryName.value,
            warehouseOutId: tempWarhouseId.value,
            warehouseId: form.warehouseId,
            content: form.reason,
            applianceIdList: list.value.map((item, index, arr) => { return item.id })
        })

        if (res.code === 200) {
          Toast.success({ message: '申请成功，等待审批！', duration: 2000, forbidClick: true })
          setTimeout(() => {
            router.back()
          }, 2000)
        } else {
          Toast.fail({ message: res.message })
        }
    }

    // 删除
    const dele = (index: any) => {
      if (list.value.length === 1) {
     //   Toast('至少保留一条工装信息')
        Toast('至少保留一条物流清单信息')
        return
      }
      list.value.splice(index, 1)
    }
    // 关闭扫码框
    const closePopup = (): void => {
        openCode.value = false
    }
    // 扫码回调
    const onDecode = async (data: string[]): Promise<void> => {
        console.log(data)
        openCode.value = false
        let res = await getBarcodeContent({
            barcode: data[0]
        })
        if (res.code === 200) {
            if (res.data.barcodeType === QRCodeType.GZ) {
                // 查看是否已有工装
                for (let i = 0; i < list.value.length; i++) {
                    if (list.value[i].id === res.data.id) {
                        Toast.fail({ message: '不能扫描重复的工装' })
                        return
                    }
                }
                // 获取工装详情
                let lk = await getListByCondition({ id: res.data.id })
                if (lk.code === 200) {
                    if (lk.data[0].qualityType === 2) {
                        console.log(tempFactoryId.value, lk.data[0].pmodelOrgId)
                        console.log(tempWarhouseId.value, lk.data[0].warehouseId)
                        if (tempFactoryId.value === lk.data[0].pmodelOrgId &&  tempWarhouseId.value === lk.data[0].warehouseId) {
                          list.value.push(lk.data[0])
                        } else {
                          Toast.fail({ message: '请扫描相同仓库的工装' })
                        }
                    } else {
                        Toast.fail({ message: '请扫描质量属性为报废的工装', duration: 2000 })
                    }
                }
            } else {
                Toast.fail({ message: '请扫描正确的工装码' })
            }
        }

    }
    // 打开扫码
    const open = (): void => {
        openCode.value = true
    }
    // 关闭仓库选择弹框
    const close = (): void => {
      warehouseShow.value = false
    }
    // 选择仓库回调
    const getValue = (item: any): void => {
      console.log(item)
      form.warehouseName = item.name
      form.warehouseId = item.id
      warehouseShow.value = false
    }

    const getLKInfo = async (id: string | number): Promise<void> => {
        let res = await getListByCondition({ id })
        if (res.code === 200) {
            if (res.data[0].qualityType === 2) {
                list.value.push(res.data[0])
                tempFactoryName.value = res.data[0].dpmodelName
                tempFactoryId.value = res.data[0].pmodelOrgId
                tempWarhouseName.value = res.data[0].whmodelName
                tempWarhouseId.value = res.data[0].warehouseId
            } else {
                Toast.fail({ message: '请扫描质量属性为报废的工装', duration: 2000 })
            }
        }
    }
  onMounted(() => {
    // 获取工装信息
    getLKInfo(route.query.id as string)
  })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(tempFactoryName)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(tempWarhouseName)), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "rework_list_item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(warehouseShow) //@ts-ignore
 ? warehouseShow.value = true : warehouseShow = true))
      }, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", {
            class: _normalizeClass(_unref(form).warehouseName ? 'black' : '')
          }, _toDisplayString(_unref(form).warehouseName ? _unref(form).warehouseName : '请点击选择类型'), 3),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            style: {"text-align":"right"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).reason) = $event)),
            placeholder: "请输入报废原因"
          }, null, 512), [
            [_vModelText, _unref(form).reason]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("span", null, _toDisplayString('报废工装清单(' + _unref(list).length + ')'), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: index }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              style: {"height":"100%"},
              square: "",
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(item.code) + "：", 1),
                _createElementVNode("span", _hoisted_22, _toDisplayString(item.num + item.umodelName), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", null, _toDisplayString(item.mmodelName + ' | ' + item.mmodelCode), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("span", null, _toDisplayString(item.batch ?? '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", null, _toDisplayString(item.pmodelName), 1)
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _hoisted_29,
    _createElementVNode("div", { class: "rework_footer" }, [
      _createElementVNode("div", {
        class: "rework_footer_add",
        onClick: open
      }, "扫码添加工装"),
      _hoisted_30,
      _createElementVNode("button", {
        class: "rework_footer_submit",
        onClick: onConfirm
      }, "提交")
    ]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(openCode),
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(Warehouse, {
      show: _unref(warehouseShow),
      systemDicDataId: '6,7',
      onClose: close,
      onValue: getValue
    }, null, 8, ["show"])
  ]))
}
}

})